import(/* webpackMode: "eager" */ "C:\\Users\\Root\\Documents\\source\\law\\frontend\\src\\app\\(site)\\page.tsx");
